import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import time from "../../../assets/images/icons/alarm-01.svg";
import arrow from "../../../assets/images/icons/arrow-right.svg";
import white_arrow from "../../../assets/images/icons/arrow_title.svg";
import User from "../../../assets/images/icons/User_01.svg";
import { GeneralButton } from "../../../components";
import i18n from "../../../i18n";
import { AllReminders, CompleteProfile } from "../../../Share";

interface ProfileCompletionCardProps {
  completePercentage: number;
}

const ProfileCompletionCard: React.FC<ProfileCompletionCardProps> = ({
  completePercentage,
}) => {
  const { t } = useTranslation();
  const lang = i18n?.language?.slice(0, 2);
  const [isOpen, setIsOpen] = useState(false);
  const [isReminderDrawerOpen, setIsReminderDrawerOpen] = useState(false);
  return (
    <>
      {completePercentage === 100 ? (
        <div className="box">
          <GeneralButton
            title={
              <div className="flex justify-between gap-2">
                <div className="flex gap-1">
                  <img className={`h-5 w-5 `} src={time} alt="" />
                  <span>{t("view_reminders")}</span>
                </div>
              </div>
            }
            color="lite"
            // icon={arrow}
            iconClass={`w-6 ${lang == "ar" ? "rotate-180" : ""}`}
            className="w-full flex-row-reverse justify-between"
            onClick={() => setIsReminderDrawerOpen(true)}
          />
        </div>
      ) : (
        <div className="box flex flex-col gap-3 !p-4 text-primary-text">
          <div className="flex gap-3 items-center "> 
             <img src={User} alt="User" className="max-xl:h-6 max-xl:w-6  h-8 w-8" />
          <h2 className="font-bold">{t("complete_profile")}</h2>
          </div>
          <h3 className="text-sm max-xl:hidden">
            {t("complete_your_profile_to_start_receiving_appointments")}
          </h3>
          <div className="flex items-center gap-2">
            <span className="text-base font-bold text-primary">
              {completePercentage}%
            </span>
            <div className="h-1 flex-1 rounded-full bg-primary-bg">
              <div
                className="h-1 rounded-full bg-primary"
                style={{ width: `${completePercentage}%` }}
              ></div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <GeneralButton
              title={
                <div className="flex gap-2">
                  <span>{t("complete")}</span>
                  <img
                    className={`w-6 ${lang == "ar" ? "rotate-180" : ""} `}
                    src={white_arrow}
                    alt=""
                  />
                </div>
              }
              color="blue"
              onClick={() => setIsOpen(true)}
              className="!w-1/2"
            />
            <GeneralButton
              title={
                <div className="flex gap-1">
                  <img className={`h-5 w-5 `} src={time} alt="" />
                  <span>{t("view_reminders")}</span>
                  {/* <img
                    className={`w-6 ${lang == "ar" ? "rotate-180" : ""} `}
                    src={arrow}
                    alt=""
                  /> */}
                </div>
              }
              color="lite"
              onClick={() => setIsReminderDrawerOpen(true)}
              className="!w-1/2"
            />
          </div>
        </div>
      )}
      {isOpen && (
        <CompleteProfile isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
      {isReminderDrawerOpen && (
        <AllReminders
          isOpen={isReminderDrawerOpen}
          onClose={() => setIsReminderDrawerOpen(false)}
        />
      )}
    </>
  );
};

export default ProfileCompletionCard;
